const config = {
  URL_SESSION_API: urlSessionForEnvirontment(),
  URL_IP_API:
    "https://ipapi.co/json/?key=M7b4ZlBUKzqx0v7rr4JNAnDTXUnj9Z6nTpyoLwLPh84pqZdz15",
  PATH_INITIATE_SESSION: "/initiateSessionDeviceEAuth",
  PATH_REVOKE_SESSION: "/revokeSessionDeviceEAuth",
  PATH_REFRESH_SESSION: "/refreshSessionDeviceEAuth",
  PATH_SYNC_LOGICAL_CLOCK: "/syncLogicalClockESessions",
  URL_ECHO_ERREPAR: "https://www.errepar.com/echo",
};

const headers = new Headers();
headers.append("Content-Type", "application/json");

let logicalClock = 0;

export const initiateSessionDeviceEAuth = async () => {
  const ipApi = await fetch(config.URL_IP_API)
    .then((response) => response.json())
    .then((data) => data)
    .catch(
      async (e) =>
        await fetch(config.URL_ECHO_ERREPAR)
          .then((data) => data.json())
          .then((responseData) => { return {
            ip: responseData.ip,
            version: "IPv4" ,
            latitude: "0",
            longitude: "0",
            country: "ECHO_COUNTRY",
            country_capital: "ECHO_CAPITAL",
            city: "ECHO_CITY"
           }})
          .catch((error) => { return {ip:"IP_NULL"}})
    );

  const { userAgent } = navigator;

  let uuidDeviceSession = localStorage.getItem("UUIDv4");

  if (!uuidDeviceSession) {
    uuidDeviceSession = await generateBrowserFingerprint(); //crypto.randomUUID();
    localStorage.setItem("UUIDv4", uuidDeviceSession);
  }

  const body = {
    uuidDeviceSession: uuidDeviceSession, //UUIDv4 provisto por el browser/app/job que solicita iniciar una nueva sesion
    timestamp: `${new Date().toISOString().split(".")[0]}-00:00`, //ISO8601 YYYYMMDDTHHMMSS.MMM+00:00
    clientAgentInfo: {
      name: navigator.version[0],
      version: navigator.version[1],
      language: navigator.language,
      supportedFeatures: null,
    },
    clientArchInfo: {
      deviceModel: userAgent.substring(
        userAgent.indexOf("(") + 1,
        userAgent.indexOf(")")
      ),
      cpuArch: navigator.platform,
      cpuModel: "",
    },
    clientLocalizationInfo: {
      ip4: ipApi.version,
      ip6: null,
      ip: ipApi.ip,
      latlong: [ipApi.latitude, ipApi.longitude],
      country: ipApi.country,
      region: ipApi.country_capital,
      city: ipApi.city,
      verified: true,
    },
  };

  const requestOption = {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body),
  };

  const response = fetch(
    config.URL_SESSION_API + config.PATH_INITIATE_SESSION,
    requestOption
  )
    .then(async (response) => {
      return await response.json();
    })
    .then((data) => {
      console.log(data.data);

      if (data.code !== 200) {
        location.replace("https://accounts.errepar.com/");
      }

      localStorage.setItem(
        "uuidBackendSession",
        data && data.data && data.data.uuidBackendSession
      );
    })
    .catch((e) => {
      console.log(e);
    });
};

navigator.version = (function () {
  var ua = navigator.userAgent;
  var tem;
  var M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return ("IE " + (tem[1] || "")).split(" ");
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null)
      return tem.slice(1).join(" ").replace("OPR", "Opera").split(" ");
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(" ").split(" ");
})();

export const syncLogicalClockESessions = async () => {
  const idInterval = setInterval(() => {
    const body = {
      feSessionID: localStorage.getItem("UUIDv4"),
      beSessionID: localStorage.getItem("uuidBackendSession"),
      timestamp: `${new Date().toISOString().split(".")[0]}-00:00`,
      logicalClock: logicalClock++,
      userLastAction: {
        noActions: "",
        reading: "",
        writing: "",
        closeAgent: "",
        crash: "",
        unSpectedDisconnect: "",
      },
    };

    const requestOption = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    };

    const response = fetch(
      config.URL_SESSION_API + config.PATH_SYNC_LOGICAL_CLOCK,
      requestOption
    )
      .then(async (response) => {
        return await response.json();
      })
      .then((data) => {
        if (data.sessionStatus.identifier === "CLOSE") {
          console.log("SESION CERRADA:::");
          shutDownSessionSysErrepar(() => {});
          clearInterval(idInterval);
        }
      })
      .catch(() => {
        clearInterval(idInterval);
        shutDownSessionSysErrepar(() => {});
      });
  }, 240000);
};

const channel = new BroadcastChannel("sesionChannel");
channel.postMessage({ sesionIniciada: true });

channel.addEventListener("message", function (event) {
  if (!event.data.sesionIniciada) {
    shutDownSessionSysErrepar(() => {});
  }
});

const revokeSessionDeviceEAuth = async () => {
  try {
    const body = {
      uuidDeviceSession: `${localStorage.getItem("UUIDv4")}:`,
    };

    const requestOption = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    };

    const response = await fetch(
      config.URL_SESSION_API + config.PATH_REVOKE_SESSION,
      requestOption
    );

    const data = await response.json();
    console.log(data);

    return;
  } catch (error) {
    console.log(error);
    return;
  }
};

/**
 Cierra la sesión en SysErrepar y realiza una acción adicional.
 @param {Function} fn - Función adicional a ejecutar después de cerrar sesión.
*/
export const shutDownSessionSysErrepar = async (fn) => {
  channel.postMessage({ sesionIniciada: false });
  await revokeSessionDeviceEAuth();
  fn();
};

window.shutDownSessionSysErrepar = shutDownSessionSysErrepar;

// Fingerprint

/**
 Genera una huella digital del navegador mediante la recopilación de diversa información del navegador
 @returns {Promise<string>} La huella digital del navegador generada.
*/

async function generateBrowserFingerprint() {
  let d = new Date().getTime(); //1º: Use miliseconds
  let d2 =
    (typeof performance !== "undefined" &&
      performance.now &&
      performance.now() * 1000) ||
    0; //2º: Use microseconds (since page-load)
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = Math.random() * 16; //random number between 0 and 16
    if (d <= 0) d = d2;
    r = (d + r) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  // var fingerprint = "";

  // Collect User-Agent
  // fingerprint += navigator.userAgent;

  // // Collect color depth
  // fingerprint += window.screen.colorDepth;

  // // Collect timezone offset
  // var timezoneOffset = new Date().getTimezoneOffset();
  // fingerprint += timezoneOffset;

  // // Collect installed plugins
  // var plugins = "";
  // for (var i = 0; i < navigator.plugins.length; i++) {
  // plugins += navigator.plugins[i].name + ";";
  // }
  // fingerprint += plugins;

  // // Collect installed fonts
  // var fonts = "";
  // var fontList = Array.from(document.fonts).map((fontFace) => fontFace.family);
  // for (var font of fontList) {
  // fonts += font + ";";
  // }
  // fingerprint += fonts;

  // // Add random UUID
  // fingerprint += crypto.randomUUID();

  // Calculate the SHA-256 hash using Web Crypto API
  // const encoder = new TextEncoder();
  // const dataBuffer = encoder.encode(fingerprint);
  // const hashBuffer = await crypto.subtle.digest("SHA-256", dataBuffer);
  // const hashArray = Array.from(new Uint8Array(hashBuffer));
  // const hashHex = hashArray
  // .map((byte) => byte.toString(16).padStart(2, "0"))
  // .join("");
  // fingerprint = hashHex;

  // return fingerprint;
}

function urlSessionForEnvirontment() {
  if (window.location.origin.includes(".dev."))
    return "https://accounts.dev.errepar.com/sessions/api/esession";
  if (window.location.origin.includes(".qa."))
    return "https://accounts.qa.errepar.com/sessions/api/esession";
  if (window.location.origin.includes(".uat."))
    return "https://accounts.uat.errepar.com/sessions/api/esession";
  return "https://accounts.errepar.com/sessions/api/esession";
}
